<template>
	<div>
		<b-row>
			<b-col lg="4">
				<FormClient :canBeUpdated="canBeUpdated" />
				<FormGenral :canBeUpdated="canBeUpdated" />
				<FormAdditionalServices :modelId="modelId" />
				<FormNote :modelId="modelId" />
				<FormVouch :modelId="modelId" />
			</b-col>
			<b-col lg="8">
				<FormService
					:class="getClassSelected(transportService.id)"
					v-for="(transportService,tIndex) in viewModel.transportServices"
					:key="tIndex"
					:index="tIndex"
					:model="transportService"
					:enableCopy="canBeUpdated"
					:formTypeWork=formTypeWork
					@clone="ADD_TRANSPORT_SERVICE_CLONE(tIndex)"
					@delete="DEL_TRANSPORT_SERVICE(tIndex)"
					@refreshModel="fetchModel"
					@changeStatus="
						(status, reasonState) => changeStatus(transportService.id, status, reasonState)
					"
					@changeWebCheckinStatus="
						status => changeWebCheckinStatus(transportService.id, status)
					"
				/>

				<div class="text-right">
					<b-button
						v-if="canBeUpdated"
						@click="ADD_TRANSPORT_SERVICE"
						class="mr-2"
						variant="success"
						><md-icon icon="add" /> Agregar servicio</b-button
					>
				</div>
			</b-col>
		</b-row>
		<DialogChangeStatus
			v-model="change.dialog"
			:modelId="modelId"
			:copyFromId="copyFromId"
			:status="change.status"
			:reasonState="change.reasonState"
			:serviceId="change.serviceId"
			@reset="resetChange"
		/>
		<input type="submit" style="display: none" />

		<DialogChangeWebCheckinStatus
			v-model="changeWC.dialog"
			:modelId="modelId"
			:copyFromId="copyFromId"
			:status="changeWC.status"
			:serviceId="changeWC.serviceId"
			@reset="resetWCChange"
		/>
	</div>
</template>

<script>
import FormClient from "./formsGroup/FormClient";
import FormGenral from "./formsGroup/FormGeneral";
import FormNote from "./formsGroup/FormNote";
import FormVouch from "./formsGroup/FormVouchers";
import FormService from "./formsGroup/FormServices";
import FormAdditionalServices from "./formsGroup/FormAdditionalServices";

import DialogChangeStatus from "./helpers/_dialogChangeState";
import DialogChangeWebCheckinStatus from './helpers/_dialogChangeWebCheckinState';
import { mapActions, mapMutations, mapState } from "vuex";
export default {
	components: {
		FormClient,
		FormGenral,
		FormVouch,
		FormNote,
		FormService,
		DialogChangeStatus,
		DialogChangeWebCheckinStatus,
		FormAdditionalServices
	},
	props: {
		canBeUpdated: Boolean,
		tsSelectedId: Number,
		modelId: Number,
		copyFromId: Number,
		formTypeWork:{
			type: String,
			required: false
		},
	},
	data: () => ({
		change: {
			serviceId: "",
			status: "canceled",
			dialog: false,
			reasonState: 'notSelected'
		},
		changeWC: {
			serviceId: "",
			status: "pending",
			dialog: false,
		}
	}),
	mounted() {
		this.fetchModel();
	},
	watch: {
		modelId() {
			this.fetchModel();
		},
		copyFromId() {
			this.fetchModel();
		}
	},
	computed: {
		...mapState("reservation", ["viewModel"])
	},
	methods: {
		...mapActions("reservation", ["_fetchModel"]),
		...mapMutations("reservation", [
			"ADD_TRANSPORT_SERVICE",
			"ADD_TRANSPORT_SERVICE_CLONE",
			"DEL_TRANSPORT_SERVICE"
		]),
		...mapMutations("reservation", ["SET_NEW_MODEL"]),
		getClassSelected(id) {
			return this.tsSelectedId === id ? "tsSelected" : "";
		},
		resetChange() {
			this.change.serviceId = "";
			this.change.status = "canceled";
			this.change.dialog = false;
		},
		changeStatus(id, status, reasonState) {
			this.change.serviceId = id;
			this.change.status = status;
			this.change.dialog = true;
			this.change.reasonState = reasonState;
		},
		resetWCChange() {
			this.changeWC.serviceId = "";
			this.changeWC.status = "pending";
			this.changeWC.dialog = false;
		},
		changeWebCheckinStatus(id, status) {
			this.changeWC.serviceId = id;
			this.changeWC.status = status;
			this.changeWC.dialog = true;
		},
		configEditMode(res) {
			let auxViewModel = JSON.parse(JSON.stringify(res.data));
			auxViewModel.clientFirstName = res.data.client.firstName;
			auxViewModel.clientLastName = res.data.client.lastName;
			auxViewModel.clientPhone = res.data.client.phone;
			auxViewModel.clientEmail = res.data.client.email;
			auxViewModel.clientLang = res.data.client.lang;
			this.SET_NEW_MODEL(auxViewModel);
		},
		configCloneMode(res) {
			let auxViewModel = JSON.parse(JSON.stringify(res.data));
			auxViewModel.id = -1;
			auxViewModel.status = "active";
			for (let i = 0; i < auxViewModel.transportServices.length; i++) {
				auxViewModel.transportServices[i].id = -1;
				auxViewModel.transportServices[i].status = "active";
				auxViewModel.transportServices[i].serviceNumber = "";
				auxViewModel.transportServices[i].supplierConfirmation =
					"pending";
				auxViewModel.transportServices[
					i
				].pickupDatetimeConfirmed = false;
				delete auxViewModel.transportServices[i].reservationId;
			}
			this.SET_NEW_MODEL(auxViewModel);
		},
		async fetchModel() {
			await this._fetchModel({
				context: this,
				modelId: this.modelId,
				copyFromId: this.copyFromId
			});
		}
	}
};
</script>
